import React, { useEffect, useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { TStaff } from 'entities/staff/model/types';
import { Task } from 'entities/task/model/types/tasks';
import { TModalMode } from 'shared/model/types/modalMode.type';
import { changeObserverIds } from '../../widgets/Modals/model/slice/addModalSlice';
import { changeEditModalObserverIds } from '../../widgets/Modals/model/slice/editModalSlice';
import { useTranslation } from 'react-i18next';

export const useObserversStaff = (modalMode: TModalMode, isDisabled: boolean) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [optionFilter, setOptionFilter] = useState('');
    const pickedTaskUid = new URLSearchParams(window.location.search).get('task_id');
    // const taskData: Task = useAppSelector((state) =>
    //     tasksSelector.selectById(state, pickedTaskUid)
    // );
    const taskData: Task = useAppSelector((state) => state.tasksReducer.entities[pickedTaskUid]);
    const dispatch = useAppDispatch();

    const { employees } = useAppSelector((state) => state.tasksInformationReducer);
    // const observersData =
    //     employees?.filter((person) => taskData?.involved?.observerIds?.includes(person.id)) || [];
    const observersData = employees.filter((obs) => {
        if (modalMode === 'addNewTask') {
            return employees;
        }
        return taskData?.involved?.observer_ids?.includes(obs.id);
    });

    const [selectedStaff, setSelectedStaff] = useState(() => {
        if (modalMode === 'addNewTask') return [];
        if (!taskData?.involved) return observersData;
        return observersData.filter((obs) => taskData.involved?.observer_ids?.includes(obs.id));
        // return observersData;
    });

    useEffect(() => {
        if (modalMode === 'addNewTask') {
            dispatch(changeObserverIds(selectedStaff.map((item) => item.id)));
        }
        if (modalMode === 'editTask') {
            dispatch(changeEditModalObserverIds(selectedStaff.map((item) => item.id)));
        }
    }, [selectedStaff]);

    const toggleDropdown = () => {
        if (isDisabled) return;
        setIsOpen(!isOpen);
    };

    const filteredOptions = useMemo(() => {
        if (!optionFilter) return observersData;

        const filtered = employees.filter((option) =>
            option.name.toLowerCase().includes(optionFilter.toLowerCase())
        );

        return filtered.length > 0
            ? filtered
            : [
                  {
                      name: t('Features.ObserversStaff.useObserversStaff.NoResults.text'),
                      avatar_url: '',
                      id: null,
                  },
              ];
    }, [observersData, optionFilter]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOptionFilter(event.target.value);
    };

    const handleOptionClick = (value: TStaff) => {
        if (value.id === null) return;
        setSelectedStaff((prev) => {
            const isSelected = prev.find((item) => item.id === value.id);
            if (isSelected) {
                return prev.filter((item) => item.id !== value.id);
            }
            return [...prev, value];
        });
    };

    return {
        filteredOptions,
        toggleDropdown,
        isOpen,
        handleInputChange,
        handleOptionClick,
        optionFilter,
        setIsOpen,
        selectedStaff,
        observersData,
        employees,
    };
};
